import React from 'react';
import { useTheme } from 'styled-components';

import { InterUIIcon } from '../../core/InterUIIcon/InterUIIcon';
import { IInterUIAlertProps } from '../../interfaces/inter-ui-alert-props';
import { Container, Content, Icon } from './InterUIAlert.styles';

/**
 * Componente Inter UI Alert.
 * @param props Propriedades disponíveis para definição do layout.
 */
export const InterUIAlert: React.FC<
  IInterUIAlertProps & React.HtmlHTMLAttributes<HTMLElement>
> = ({ margin, type, children, color, icon, ...props }) => {
  const theme = useTheme();

  const renderIconType = () => {
    switch (type) {
      case 'error':
        return (
          <InterUIIcon
            name='contextual-error'
            size='sm'
            color={theme.colors.feedback.error.A500}
          />
        );
      case 'attention':
        return (
          <InterUIIcon
            name='contextual-attention'
            size='sm'
            color={theme.colors.feedback.warning.A500}
          />
        );
      case 'security':
        return (
          <InterUIIcon
            name='security'
            size='sm'
            color={theme.colors.neutral.grayscale.A500}
          />
        );
      default:
        return (
          <InterUIIcon
            name='contextual-info'
            size='sm'
            color={theme.colors.neutral.grayscale.A300}
          />
        );
    }
  };

  return (
    <Container
      margin={margin}
      type={type}
      color={color}
      data-testid='inter-ui-alert'
      {...props}
    >
      <Icon data-testid='inter-ui-alert-icon'>{icon || renderIconType()}</Icon>
      <Content>{children}</Content>
    </Container>
  );
};
